import type { ArtworkMedium } from "./artworkPaths";
import { artworkPagePath } from "./artworkPaths";

export function artworkShareUrl(medium: ArtworkMedium, id: string): string {
  return `${window.location.origin}${artworkPagePath(medium, id)}`;
}

export type ShareArtworkResult = "shared" | "copied";

export async function shareArtwork({
  medium,
  id,
  title,
  text,
}: {
  medium: ArtworkMedium;
  id: string;
  title: string;
  text?: string;
}): Promise<ShareArtworkResult> {
  const url = artworkShareUrl(medium, id);
  const payload: ShareData = { title, url };
  if (text) payload.text = text;

  if (typeof navigator !== "undefined" && typeof navigator.share === "function") {
    try {
      await navigator.share(payload);
      return "shared";
    } catch (error) {
      if (error instanceof DOMException && error.name === "AbortError") {
        throw error;
      }
    }
  }

  await navigator.clipboard.writeText(url);
  return "copied";
}
